/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generic export response handler. Can be implemented to handle export responses like partial success.
 */
export interface IOtlpResponseHandler<Response> {
  /**
   * Handles an OTLP export response.
   * Implementations MUST NOT throw.
   * @param response
   */
  handleResponse(response: Response): void;
}
